import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "app-page-header" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = {
  key: 0,
  class: "subtitle"
}
const _hoisted_4 = {
  key: 1,
  class: "header-meta"
}
const _hoisted_5 = { class: "actions" }

import { computed } from 'vue'

// Define props interface
interface Props {
  title: string
  subtitle?: string
  useGradient?: boolean
}

// Define props with defaults

export default /*@__PURE__*/_defineComponent({
  __name: 'AppPageHeader',
  props: {
    title: {},
    subtitle: { default: '' },
    useGradient: { type: Boolean, default: true }
  },
  setup(__props: any) {

/// <reference types="vue" />
// @ts-ignore
const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", {
        class: _normalizeClass(["title", { 'title-gradient': _ctx.useGradient }])
      }, _toDisplayString(_ctx.title), 3),
      (_ctx.subtitle)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.subtitle), 1))
        : _createCommentVNode("", true),
      (_ctx.$slots.meta)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "meta")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "actions")
    ])
  ]))
}
}

})